<template>
  <b-container fluid>
    <h1>Check In</h1>
    <b-form-group label="Filters">
      <b-form-radio-group
        id="list-filters"
        v-model="selectedFilter"
        :options="filters"
        name="filters"
      ></b-form-radio-group>
    </b-form-group>
    <b-form-input v-model="searchTeam" placeholder="Search Team"></b-form-input>
    <b-table
      :fields="fields"
      head-variant="dark"
      :items="items"
      small
      sort-icon-left
      sort-by="team"
      :tbody-tr-class="rowClass"
    >
      <template v-slot:cell(status)="data">
        <b-button
          block
          size="sm"
          variant="primary"
          v-if="!data.item.checkedIn"
          @click="changeStatus(data.item.id, true)"
        >Check-In
        </b-button>
        <b-button
          size="sm"
          variant="outline-danger"
          v-else
          @click="changeStatus(data.item.id, false)"
        >X
        </b-button>
      </template>
    </b-table>
  </b-container>
</template>

<script>
export default {
  name: 'CheckIn',
  data() {
    return {
      fields: [
        { key: 'team', sortable: true },
        { key: 'first_name', sortable: true },
        { key: 'last_name', sortable: true },
        { key: 'status', sortable: true },
      ],
      filters: [
        { text: 'All', value: null },
        { text: 'Checked in', value: true },
        { text: 'Waiting', value: false },
      ],
      searchTeam: '',
      selectedFilter: null,
    };
  },
  methods: {
    changeStatus(id, status) {
      this.$store.commit('setValue', {
        id,
        key: 'checkedIn',
        value: status,
      });
    },
    rowClass(item) {
      return item.checkedIn === true
        ? 'table-success'
        : '';
    },
  },
  computed: {
    items() {
      let { participants } = this.$store.state;
      if (this.searchTeam !== '') {
        participants = participants.filter((p) => p.team.toLowerCase()
          .includes(this.searchTeam.toLowerCase()));
      }
      if (this.selectedFilter !== null) {
        participants = participants.filter((p) => p.checkedIn === this.selectedFilter);
      }
      return participants;
    },
  },
};
</script>
